// // 🌐 Base URLs
// const BASE_URL_MAMA = "https://backend.maamaas.com/subscription";
// const BASE_URL_CATERINGS = "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT";

// // ============================================================
// // 🔐 TOKEN MANAGEMENT
// // ============================================================

// // ✅ Save token
// export const setAuthToken = (token) => {
//     if (token) {
//         localStorage.setItem("authToken", token);
//     } else {
//         localStorage.removeItem("authToken");
//     }
// };

// // ✅ Get token
// export const getAuthToken = () => {
//     return localStorage.getItem("authToken");
// };

// // ✅ Remove token (for logout)
// export const clearAuthToken = () => {
//     localStorage.removeItem("authToken");
// };

// // ============================================================
// // 🔐 Authorization helpers
// // ============================================================

// const getAuthHeaders = () => {
//     const token = getAuthToken();
//     if (!token) throw new Error("Authentication token is missing!");
//     return {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//     };
// };

// const getAuthOnlyHeaders = () => {
//     const token = getAuthToken();
//     if (!token) throw new Error("Authentication token is missing!");
//     return {
//         Authorization: `Bearer ${token}`,
//     };
// };

// // ============================================================
// // 🧩 MAMAS WEBSITE COUPON APIs
// // ============================================================

// // ✅ Fetch all coupons
// export const fetchCouponsAPI = async () => {
//     const res = await fetch(`${BASE_URL_MAMA}/coupon`, {
//         headers: getAuthHeaders(),
//     });
//     if (!res.ok) throw new Error("Failed to fetch coupons");
//     return await res.json();
// };

// // ✅ Add new coupon
// export const createCouponAPI = async (payload) => {
//     const res = await fetch(`${BASE_URL_MAMA}/coupon`, {
//         method: "POST",
//         headers: getAuthHeaders(),
//         body: JSON.stringify(payload),
//     });
//     if (!res.ok) throw new Error(await res.text());
//     return await res.json();
// };

// // ✅ Update existing coupon
// export const updateCouponAPI = async (id, payload) => {
//     const res = await fetch(`${BASE_URL_MAMA}/coupon/${id}`, {
//         method: "PUT",
//         headers: getAuthHeaders(),
//         body: JSON.stringify(payload),
//     });
//     if (!res.ok) throw new Error(await res.text());
//     return await res.json();
// };

// // ✅ Delete coupon
// export const deleteCouponAPI = async (id) => {
//     const res = await fetch(`${BASE_URL_MAMA}/coupon/${id}`, {
//         method: "DELETE",
//         headers: getAuthHeaders(),
//     });
//     if (!res.ok) throw new Error("Failed to delete coupon");
//     return true;
// };

// // ============================================================
// // 🍽️ CATERINGS COUPON APIs (multipart/form-data)
// // ============================================================

// // ✅ Fetch all catering coupons
// export const fetchCateringsCouponsAPI = async () => {
//     const res = await fetch(`${BASE_URL_CATERINGS}/api/admin/catering/coupon/getall`, {
//         method: "GET",
//         headers: getAuthOnlyHeaders(),
//     });
//     if (!res.ok) throw new Error("Failed to fetch catering coupons");
//     return await res.json();
// };

// // ✅ Create new catering coupon (multipart/form-data)
// // ✅ Create new catering coupon (multipart/form-data)
// export const createCateringsCouponAPI = async (couponData, imageFile) => {
//     const token = localStorage.getItem("authToken");
//     const formData = new FormData();

//     // ✅ Append JSON data as a blob (type: application/json)
//     formData.append(
//         "couponData",
//         new Blob([JSON.stringify(couponData)], { type: "application/json" })
//     );

//     // ✅ Append image file if available
//     if (imageFile) {
//         formData.append("image", imageFile);
//     }

//     try {
//         const res = await fetch(
//             `${BASE_URL_CATERINGS}/api/admin/catering/coupon/add`,
//             {
//                 method: "POST",
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     Accept: "*/*",
//                     // ❌ Don't add Content-Type manually (browser will add it automatically)
//                 },
//                 body: formData,
//             }
//         );

//         if (!res.ok) {
//             const errorText = await res.text();
//             throw new Error(errorText || `HTTP ${res.status}`);
//         }

//         const result = await res.json();
//        // console.log("✅ Coupon created successfully:", result);
//         return result;
//     } catch (err) {
//         console.error("❌ Error creating catering coupon:", err);
//         throw err;
//     }
// };

// // ✅ Update catering coupon
// // ✅ Update catering coupon (multipart/form-data)
// export const updateCateringsCouponAPI = async (id, couponData, imageFile) => {
//     const token = localStorage.getItem("authToken");
//     const formData = new FormData();

//     // ✅ Append JSON data as Blob (for Spring Boot compatibility)
//     formData.append(
//         "couponData",
//         new Blob([JSON.stringify(couponData)], { type: "application/json" })
//     );

//     // ✅ Append image file if available
//     if (imageFile) {
//         formData.append("image", imageFile);
//     }

//     try {
//         const res = await fetch(
//             `${BASE_URL_CATERINGS}/api/admin/catering/coupon/update/${id}`,
//             {
//                 method: "PUT", // ✅ correct method (backend expects PUT)
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     Accept: "*/*",
//                     // ❌ DO NOT add Content-Type manually for multipart
//                 },
//                 body: formData,
//             }
//         );

//         if (!res.ok) {
//             const errorText = await res.text();
//             throw new Error(errorText || `HTTP ${res.status}`);
//         }

//         const result = await res.json();

//         alert(
//             `✅ Coupon Updated Successfully!\n\n📜 Data: ${JSON.stringify(
//                 couponData,
//                 null,
//                 2
//             )}\n🖼️ Image: ${imageFile?.name || "No image uploaded"}`
//         );

//        // console.log("✅ Coupon updated:", result);
//         return result;
//     } catch (err) {
//         console.error("❌ Error updating catering coupon:", err);
//         alert("❌ Failed to update coupon. Check console for details.");
//         throw err;
//     }
// };


// // ✅ Delete catering coupon
// export const deleteCateringsCouponAPI = async (id) => {
//     const res = await fetch(`${BASE_URL_CATERINGS}/api/admin/catering/coupon/delete/${id}`, {
//         method: "DELETE",
//         headers: getAuthOnlyHeaders(),
//     });

//     if (!res.ok) throw new Error("Failed to delete catering coupon");
//     return true;
// };


// 🌐 Base URLs
const BASE_URL_MAMA = "https://backend.maamaas.com/food";
const BASE_URL_CATERINGS = "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT";
const BASE_URL_GROCERY = "http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT";

// ============================================================
// 🔐 TOKEN MANAGEMENT
// ============================================================

// ✅ Save token
export const setAuthToken = (token) => {
    if (token) {
        localStorage.setItem("authToken", token);
    } else {
        localStorage.removeItem("authToken");
    }
};

// ✅ Get token
export const getAuthToken = () => {
    return localStorage.getItem("authToken");
};

// ✅ Remove token (for logout)
export const clearAuthToken = () => {
    localStorage.removeItem("authToken");
};

// ============================================================
// 🔐 Authorization helpers
// ============================================================

const getAuthHeaders = () => {
    const token = getAuthToken();
    if (!token) throw new Error("Authentication token is missing!");
    return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    };
};

const getAuthOnlyHeaders = () => {
    const token = getAuthToken();
    if (!token) throw new Error("Authentication token is missing!");
    return {
        Authorization: `Bearer ${token}`,
    };
};

// ============================================================
// 🧩 MAMAS WEBSITE COUPON APIs
// ============================================================

// ✅ Fetch all coupons

// // ✅ Fetch all coupons
export const fetchCouponsAPI = async () => {
    const res = await fetch(`${BASE_URL_MAMA}/api/coupon`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw new Error("Failed to fetch coupons");
    return await res.json();
};

// ✅ Add new coupon
export const createCouponAPI = async (payload) => {
    const res = await fetch(`${BASE_URL_MAMA}/api/coupon`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
};

// ✅ Update existing coupon
export const updateCouponAPI = async (id, payload) => {
    const res = await fetch(`${BASE_URL_MAMA}/api/coupon/${id}`, {
        method: "PUT",
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
};

// ✅ Delete coupon
export const deleteCouponAPI = async (id) => {
    const res = await fetch(`${BASE_URL_MAMA}/api/coupon/${id}`, {
        method: "DELETE",
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw new Error("Failed to delete coupon");
    return true;
};

// ============================================================
// 🍽️ CATERINGS COUPON APIs (multipart/form-data)
// ============================================================

// ✅ Fetch all catering coupons
export const fetchCateringsCouponsAPI = async () => {
    const res = await fetch(`${BASE_URL_CATERINGS}/api/admin/catering/coupon/getall`, {
        method: "GET",
        headers: getAuthOnlyHeaders(),
    });
    if (!res.ok) throw new Error("Failed to fetch catering coupons");
    return await res.json();
};

// ✅ Create new catering coupon (multipart/form-data)
// ✅ Create new catering coupon (multipart/form-data)
export const createCateringsCouponAPI = async (couponData, imageFile) => {
    const token = localStorage.getItem("authToken");
    const formData = new FormData();

    // ✅ Append JSON data as a blob (type: application/json)
    formData.append(
        "couponData",
        new Blob([JSON.stringify(couponData)], { type: "application/json" })
    );

    // ✅ Append image file if available
    if (imageFile) {
        formData.append("image", imageFile);
    }

    try {
        const res = await fetch(
            `${BASE_URL_CATERINGS}/api/admin/catering/coupon/add`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                    // ❌ Don't add Content-Type manually (browser will add it automatically)
                },
                body: formData,
            }
        );

        if (!res.ok) {
            const errorText = await res.text();
            throw new Error(errorText || `HTTP ${res.status}`);
        }

        const result = await res.json();
        // console.log("✅ Coupon created successfully:", result);
        return result;
    } catch (err) {
        console.error("❌ Error creating catering coupon:", err);
        throw err;
    }
};

// ✅ Update catering coupon
// ✅ Update catering coupon (multipart/form-data)
export const updateCateringsCouponAPI = async (id, couponData, imageFile) => {
    const token = localStorage.getItem("authToken");
    const formData = new FormData();

    // ✅ Append JSON data as Blob (for Spring Boot compatibility)
    formData.append(
        "couponData",
        new Blob([JSON.stringify(couponData)], { type: "application/json" })
    );

    // ✅ Append image file if available
    if (imageFile) {
        formData.append("image", imageFile);
    }

    try {
        const res = await fetch(
            `${BASE_URL_CATERINGS}/api/admin/catering/coupon/update/${id}`,
            {
                method: "PUT", // ✅ correct method (backend expects PUT)
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                    // ❌ DO NOT add Content-Type manually for multipart
                },
                body: formData,
            }
        );

        if (!res.ok) {
            const errorText = await res.text();
            throw new Error(errorText || `HTTP ${res.status}`);
        }

        const result = await res.json();

        alert(
            `✅ Coupon Updated Successfully!\n\n📜 Data: ${JSON.stringify(
                couponData,
                null,
                2
            )}\n🖼️ Image: ${imageFile?.name || "No image uploaded"}`
        );

        // console.log("✅ Coupon updated:", result);
        return result;
    } catch (err) {
        console.error("❌ Error updating catering coupon:", err);
        alert("❌ Failed to update coupon. Check console for details.");
        throw err;
    }
};


// ✅ Delete catering coupon
export const deleteCateringsCouponAPI = async (id) => {
    const res = await fetch(`${BASE_URL_CATERINGS}/api/admin/catering/coupon/delete/${id}`, {
        method: "DELETE",
        headers: getAuthOnlyHeaders(),
    });

    if (!res.ok) throw new Error("Failed to delete catering coupon");
    return true;
};


// Grocery




// ✅ Fetch all coupons
// export const fetchGroceryCouponsAPI = async () => {
//     const res = await fetch(`${BASE_URL_GROCERY}/api/admin/grocery/coupon/getall`, {
//         headers: getAuthHeaders(),
//     });
//     if (!res.ok) throw new Error("Failed to fetch coupons");
//     return await res.json();
// };



export const fetchGroceryCouponsAPI = async () => {
    const token = localStorage.getItem("authToken");
    const url = `${BASE_URL_GROCERY}/api/admin/grocery/coupon/getall`;
    // console.log("Fetching coupons from:", url);

    const res = await fetch(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
    return await res.json();
};


// ✅ Add new coupon
// export const createGroceryCouponAPI = async (payload) => {
//     const res = await fetch(`${BASE_URL_GROCERY}/api/admin/grocery/coupon/add`, {
//         method: "POST",
//         headers: getAuthHeaders(),
//         body: JSON.stringify(payload),
//     });
//     if (!res.ok) throw new Error(await res.text());
//     return await res.json();
// };

export const createGroceryCouponAPI = async (couponData, imageFile) => {
    const token = localStorage.getItem("authToken");
    const formData = new FormData();

    // ✅ Append couponData JSON as Blob
    formData.append(
        "couponData",
        new Blob([JSON.stringify(couponData)], { type: "application/json" })
    );

    // ✅ Append image if available
    if (imageFile) {
        formData.append("image", imageFile);
    }

    const res = await fetch(
        `${BASE_URL_GROCERY}/api/admin/grocery/coupon/add`,
        {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "*/*",
                // ❌ Don't set Content-Type manually; browser sets it automatically
            },
            body: formData,
        }
    );

    if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || `HTTP ${res.status}`);
    }

    const result = await res.json();
    // console.log("✅ Coupon created successfully:", result);
    return result;
};


// ✅ Update existing coupon
export const updateGroceryCouponAPI = async (id, couponData, imageFile) => {
    const token = localStorage.getItem("authToken");
    const formData = new FormData();

    formData.append(
        "couponData",
        new Blob([JSON.stringify(couponData)], { type: "application/json" })
    );

    if (imageFile) {
        formData.append("image", imageFile);
    }

    const res = await fetch(
        `${BASE_URL_GROCERY}/api/admin/grocery/coupon/update/${id}`,
        {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "*/*",
            },
            body: formData,
        }
    );

    if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || `HTTP ${res.status}`);
    }

    return await res.json();
};






// ✅ Delete coupon
export const deleteGroceryCouponAPI = async (id) => {
    const res = await fetch(`${BASE_URL_GROCERY}/api/admin/grocery/coupon/delete/${id}`, {
        method: "DELETE",
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw new Error("Failed to delete coupon");
    return true;
};